var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { getNumberFromSizeString } from './loader.utils';
var MAX_VALUE = 100;
var DEFAULT_THICKNESS = 2.5;
var DEFAULT_SIZE = 32;
export var CircularProgress = React.forwardRef(function (props, ref) {
    var className = props.className, _a = props.component, Component = _a === void 0 ? 'div' : _a, _b = props.size, size = _b === void 0 ? DEFAULT_SIZE : _b, style = props.style, _c = props.thickness, thickness = _c === void 0 ? DEFAULT_THICKNESS : _c, _d = props.value, value = _d === void 0 ? 100 : _d, restProps = __rest(props, ["className", "component", "size", "style", "thickness", "value"]);
    var computedSize = getNumberFromSizeString(size);
    var radius = computedSize / 2 - thickness;
    var circumference = radius * 2 * Math.PI;
    var progressOffset = circumference - (value / MAX_VALUE) * circumference;
    return (_jsx(Component, __assign({ "aria-busy": value < 100, "aria-valuenow": value, className: className, max: 100, ref: ref, role: "progressbar", "aria-label": "progress", value: value }, restProps, { children: _jsx("svg", __assign({ width: size, height: size }, { children: _jsx("circle", { style: {
                    strokeDasharray: "".concat(circumference, " ").concat(circumference),
                    strokeDashoffset: "".concat(progressOffset),
                }, stroke: 'currentColor', strokeWidth: thickness, fill: "transparent", r: radius, cx: computedSize / 2, cy: computedSize / 2 }) })) })));
});
CircularProgress.displayName = 'CircularProgress';
